<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
                                            <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>Blog List<small><i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1>
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Apps</a></li>
                <li class="active">Blog List Page</li>
            </ol>
        </section>
            <!-- Main content -->
            <section class="content">
                <div class="box" style="padding:30px;">
                    <div class="row">
                        <!--  BLOG CONTENT -->
                        <div class="col-sm-8">
                            <div class="blog-list-nest">
                                <div class="vendor"> <img class="img-responsive-media" src="https://source.unsplash.com/collection/190727/1600x900" alt=""> </div>
                                <div class="blog-list-content">
                                    <h2>Article Heading</h2>
                                    <ul class="list-inline blog-devin-tag">
                                        <li>
                                            <a href="#"> <span class="ti-pencil"></span>&nbsp;2 Days Ago</a>
                                        </li>
                                        <li>
                                            <a href="#"> <span class="ti-comment-alt"></span>&nbsp;2 Comments</a>
                                        </li>
                                        <li>
                                            <a href="#"> <span class="ti-rss-alt"></span>&nbsp;14 Shares</a>
                                        </li>
                                    </ul>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.</p>
                                    <hr>
                                    <p class="pull-left">      <el-tag type="gray">Music</el-tag>                                 <el-tag type="gray">Video</el-tag>                                 <el-tag type="gray">Typhography</el-tag> </p>
                                    <button class="btn btn-info pull-right">Read More</button>
                                    <div style="clear:both;"></div>
                                </div>
                            </div>
                            <div class="blog-list-nest">
                                <div class="vendor">
                                    <img class="img-responsive-media" src="https://source.unsplash.com/category/buildings/1024x764" alt="">
                                </div>
                                <div class="blog-list-content">
                                    <h2>Godzilla</h2>
                                    <ul class="list-inline blog-devin-tag">
                                        <li>
                                            <a href="#"> <span class="ti-pencil"></span>&nbsp;2 Days Ago</a>
                                        </li>
                                        <li>
                                            <a href="#"> <span class="ti-comment-alt"></span>&nbsp;2 Comments</a>
                                        </li>
                                        <li>
                                            <a href="#"> <span class="ti-rss-alt"></span>&nbsp;14 Shares</a>
                                        </li>
                                    </ul>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.</p>
                                    <hr>
                                    <p class="pull-left">      <el-tag type="gray">Music</el-tag>                                 <el-tag type="gray">Video</el-tag>                                 <el-tag type="gray">Typhography</el-tag> </p>
                                    <button class="btn btn-info pull-right">Read More</button>
                                    <div style="clear:both;"></div>
                                </div>
                            </div>
                            <div class="blog-list-nest">
                                <div class="vendor">
                                    <blockquote>
                                        <p>"How can we win when fools can be king"</p>
                                        <p> <small>Mattew Bellamy</small> </p>
                                    </blockquote>
                                </div>
                                <div class="blog-list-content">
                                    <h2>Muse</h2>
                                    <ul class="list-inline blog-devin-tag">
                                        <li>
                                            <a href="#"> <span class="ti-pencil"></span>&nbsp;2 Days Ago</a>
                                        </li>
                                        <li>
                                            <a href="#"> <span class="ti-comment-alt"></span>&nbsp;2 Comments</a>
                                        </li>
                                        <li>
                                            <a href="#"> <span class="ti-rss-alt"></span>&nbsp;14 Shares</a>
                                        </li>
                                    </ul>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.</p>
                                    <hr>
                                    <p class="pull-left">      <el-tag type="gray">Music</el-tag>                                 <el-tag type="gray">Video</el-tag>                                 <el-tag type="gray">Typhography</el-tag> </p>
                                    <button class="btn btn-info pull-right">Read More</button>
                                    <div style="clear:both;"></div>
                                </div>
                            </div>
                            <div class="blog-list-nest">
                                 <div class="vendor">
                                    <img class="img-responsive-media" src="https://source.unsplash.com/category/people/1024x764" alt="">
                                </div>
                                <div class="blog-list-content">
                                    <h2>Favright</h2>
                                    <ul class="list-inline blog-devin-tag">
                                        <li>
                                            <a href="#"> <span class="ti-pencil"></span>&nbsp;2 Days Ago</a>
                                        </li>
                                        <li>
                                            <a href="#"> <span class="ti-comment-alt"></span>&nbsp;2 Comments</a>
                                        </li>
                                        <li>
                                            <a href="#"> <span class="ti-rss-alt"></span>&nbsp;14 Shares</a>
                                        </li>
                                    </ul>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.</p>
                                    <hr>
                                    <p class="pull-left">      <el-tag type="gray">Music</el-tag>                                 <el-tag type="gray">Video</el-tag>                                 <el-tag type="gray">Typhography</el-tag> </p>
                                    <button class="btn btn-info pull-right">Read More</button>
                                    <div style="clear:both;"></div>
                                </div>
                            </div>
                            <ul class="pager success">
                                <li class="previous"><a href="#">← Older</a> </li>
                                <li class="next disabled"><a href="#">Newer →</a> </li>
                            </ul>
                        </div>
                        <!--  END OF BLOG CONTENT -->
                        <!--  BLOG SIDE CONTENT -->
                        <div class="col-sm-4">
                            <div class="panel panel-default"> <img class="media-object img-circle blog-profile" data-src="holder.js/64x64" alt="64x64" src="http://api.randomuser.me/portraits/thumb/men/10.jpg">
                                <hr style="margin:0;">
                                <div class="panel-body">
                                    <p class="lead text-center">Dave Mattew</p>
                                    <p class="tex-center social-blog-profile">
                                        <a href="#"> <span class="entypo-facebook-circled"></span> </a>
                                        <a class="tweet-link" href="#"> <span class="entypo-twitter-circled"></span> </a>
                                        <a class="gplus-textcolor" href="#"> <span class="entypo-instagrem"></span> </a>
                                    </p>
                                    <p class="social-follower text-center">A graphics designer, a web developer, a boyfriend, a friend, a son</p>
                                </div>
                            </div>
                            <div class="blog-side-nest">
                                <h4 class="text-center">JOIN NEWSLETTER</h4>
                                <p class="text-center">Sign up for our daily Newslatter</p>
                                <form role="form">
                                    <div class="row">
                                        <div class="col-xs-8">
                                            <div class="form-group">
                                                <input type="email" class="form-control" placeholder="Enter email"> </div>
                                        </div>
                                        <!-- /.col-xs-8 -->
                                        <div class="col-xs-4 col-full-width-left">
                                            <button type="submit" class="btn btn-info btn-block">Sign up</button>
                                        </div>
                                        <!-- /.col-xs-4 -->
                                    </div>
                                    <!-- /.row -->
                                </form>
                            </div>
                            <div class="blog-side-nest">
                                <h4 class="text-left">POPULAR POST</h4>
                                <hr style="margin:0">
                                <div class="media">
                                    <a class="pull-left" href="#"> <img class="media-object img-responsive-media" data-src="holder.js/64x64" alt="64x64" src="http://api.randomuser.me/portraits/men/17.jpg"> </a>
                                    <div class="media-body">
                                        <h5 class="media-heading">Cras sit amet nibh Lorem ipsum dolor si amet</h5> <a class="link-comment recentpost-link" style="margin:-10px 0 10px" href="#">88 Views</a> </div>
                                </div>
                                <div class="media">
                                    <a class="pull-left" href="#"> <img class="media-object img-responsive-media" data-src="holder.js/64x64" alt="64x64" src="http://api.randomuser.me/portraits/men/21.jpg"> </a>
                                    <div class="media-body">
                                        <h5 class="media-heading">Cras sit amet nibh Lorem ipsum dolor si amet</h5> <a class="link-comment recentpost-link" style="margin:-10px 0 10px" href="#">90 Views</a> </div>
                                </div>
                                <div class="media">
                                    <a class="pull-left" href="#"> <img class="media-object img-responsive-media" data-src="holder.js/64x64" alt="64x64" src="http://api.randomuser.me/portraits/men/20.jpg"> </a>
                                    <div class="media-body">
                                        <h5 class="media-heading">Cras sit amet nibh Lorem ipsum dolor si amet</h5> <a class="link-comment recentpost-link" style="margin:-10px 0 10px" href="#">42 Views</a> </div>
                                </div>
                                <div class="media">
                                    <a class="pull-left" href="#"> <img class="media-object img-responsive-media" data-src="holder.js/64x64" alt="64x64" src="http://api.randomuser.me/portraits/men/19.jpg"> </a>
                                    <div class="media-body">
                                        <h5 class="media-heading">Cras sit amet nibh Lorem ipsum dolor si amet</h5> <a class="link-comment recentpost-link" style="margin:-10px 0 10px" href="#">111 Views</a> </div>
                                </div>
                                <div class="media">
                                    <a class="pull-left" href="#"> <img class="media-object img-responsive-media" data-src="holder.js/64x64" alt="64x64" src="http://api.randomuser.me/portraits/men/18.jpg"> </a>
                                    <div class="media-body">
                                        <h5 class="media-heading">Cras sit amet nibh Lorem ipsum dolor si amet</h5> <a class="link-comment recentpost-link" style="margin:-10px 0 10px" href="#">123 Views</a> </div>
                                </div>
                                <br> </div>
                            <div class="blog-side-nest">
                                <h4 class="text-left">TAG</h4>
                                <hr style="margin:0">
                                <el-tag type="gray">Admin</el-tag>
                                <el-tag type="gray">Fleet</el-tag>
                                <el-tag type="gray">Music</el-tag>
                                <el-tag type="gray">Video</el-tag>
                                <el-tag type="gray">Typhography</el-tag>
                                <el-tag type="gray">Computer</el-tag>
                                <el-tag type="gray">Web Design</el-tag>
                                <el-tag type="gray">Movie</el-tag>

                            </div>
                        </div>
                        <!--  END OF BLOG SIDE CONTENT -->
                    </div>
                </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
  export default {
    name: 'BlogList'
  }
</script>


// WEBPACK FOOTER //
// BlogList.vue?5bd54370